<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1">With Love to</div>
<div> <br/></div><div class="ctag1">PEGGY LEACH</div>
<div class="ctag1"><i>without whom this book and our business would not have been possible.</i></div>
<div> <br/></div><div class="ctag1">GORDON AND BONNIE NEGEN</div>
<div class="ctag1"><i>for their unfailing support, including the many “How’d you do today?” phone calls in the early days of the Mackinaw Kite Co.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nege_9781118044704_oeb_ded_r1.vue?32f030fc